import React from 'react'
import clsx from 'classnames'
import styles from './OrderButton.module.css'

type OrderButtonProps = {
  onClick: () => void,
  className?: string,
}

/** The «Записаться» button in the header */
export const OrderButton: React.FC<OrderButtonProps> = (props) => {
  const { onClick, className } = props
  return (
    <button onClick={onClick} className={clsx([styles.headerBtn, className])}>
      Записаться
    </button>
  )
}
